import { Vue, Component, Prop } from 'vue-property-decorator'
import { TableHeader, CustomerAccess } from '@/types'
import Axios from 'axios'

@Component
export default class CustomersListCompnent extends Vue {
  search = ''
  snackbar = false
  message = ''
  headers: TableHeader[] = [
    {
      text: 'DNI / RUC',
      value: 'id'
    },
    {
      text: 'Nombre / Razón Social',
      value: 'name'
    },
    {
      text: 'Opciones',
      value: 'status'
    }
  ]

  @Prop()
  isLoading!: boolean

  @Prop()
  items!: CustomerAccess[]

  toggleAccess (item: CustomerAccess) {
    let uri = ''
    if (item.status === 1) {
      uri = `/customers/denied/${item.id}`
    } else {
      uri = `/customers/permission/${item.id}`
    }
    this.snackbar = false
    Axios.post(uri).then((response) => {
      item.status = item.status === 1 ? 0 : 1
      this.message = response.data.message
      this.snackbar = true
    })
  }
}
